import type { ItemV2 } from '@/common/api/types/items';

export function systemProgressToProgress(
  itemId: number,
  progressMap: Map<number, number>,
): number | null {
  const value = progressMap.get(itemId);
  return value !== undefined ? value : null;
}

export function progressFieldIdToProgress(
  fieldId: number | null,
  item: Pick<ItemV2, 'customFieldValues'>,
): number | null {
  if (!fieldId) return null;
  const customFieldObj = item.customFieldValues?.[fieldId];

  if (
    customFieldObj == null ||
    Array.isArray(customFieldObj) ||
    typeof customFieldObj === 'boolean'
  ) {
    return null;
  }
  const customFieldValue = Number(customFieldObj.value);
  if (Number.isNaN(customFieldValue)) return null;
  const normalized = customFieldValue > 1 ? customFieldValue / 100 : customFieldValue;
  return Math.min(1, Math.max(0, normalized));
}
